import { resultSort } from "init/sort";
import Query from "qpr-base/querybuilder/Query";
import { QueryInterface } from "qpr-base/querybuilder/QueryBuilder";
import { convertItemListToPeriod } from "./convertItemListToPeriod";
import { ICardElementWithChildren, IPeriod, IPeriodLevel } from "./model";

export const getChildHierarchy = async (
  id: string,
  attrs: (params: QueryInterface) => QueryInterface,
  depth: number,
  period: IPeriod,
  allPeriods: IPeriodLevel[]
) => {
  const recursive = depth || 10;
  const base = (q: QueryInterface) => {
    if (attrs) return attrs(q);
    return q;
  };
  /*
    
    .then((values) => {
      return convertItemListToPeriod(values, period!);
    })
*/
  return base(Query(id).childobjects({ recursive }))
    .fetchValues<ICardElementWithChildren>()
    .then((values) => {
      return convertItemListToPeriod(values, period!, allPeriods);
    })
    .then((values) => {
      const mapChildrenOf = (
        list: ICardElementWithChildren[],
        parentId?: string
      ) => {
        const children = list.filter(
          (item) => item.parent_element_id === parentId
        );
        children.forEach((item) => {
          item.children = mapChildrenOf(list, item.id);
        });
        return children;
      };
      return resultSort(mapChildrenOf(values, id));
    });
};
